import { useEffect, useState } from 'react';
import { getEditorColor, renderColor } from '../../../util/ColorUtil';
import {
  getEditorColors,
  getRegionIcon,
  isItUndefined,
  modifyLinks,
} from '../../../util/DataUtil';
import FacilityAccordion from './facility-accordion';
import { cleanHTML } from '../../utils/htmlUtils';

const FacilityAccordionBlock = (props) => {
  const accordionVariant = props?.children?.field_accordion_variant[0]?.value;
  const initialData =
    props?.children?.field_facility_accordion_list?.facility_accordion || [];
  const [data, setData] = useState(
    initialData.length > 5 ? initialData.slice(0, 5) : initialData
  );
  const useTitleAsSmallHeadLine =
    isItUndefined(props?.children?.field_use_title_as_headline) == '1';
  const emphasizedTextColor = getEditorColors(
    isItUndefined(props?.children?.field_formatted_title),
    isItUndefined(props?.children?.field_description)
  ).filter((x) => x)[0];
  const [isCertificationsPage, setIsCertificationsPage] = useState(null);

  useEffect(() => {
    const urlContainsWords = (word1, word2) => {
      const url = window.location.href;
      return url.includes(word1) && url.includes(word2);
    };
    if (urlContainsWords('data-centers', 'certifications')) {
      setIsCertificationsPage(true);
    }
    if (initialData.length > 5) {
      setData(initialData.slice(0, 5));
    }
  }, [initialData]);

  const renderAccordions = (items) => {
    if (!items?.length) {
      return;
    }

    return items.map((item, index) => {
      return (
        <div className="accordion" key={`accordion-index-${index}`}>
          <FacilityAccordion
            width={props.width}
            color={props?.regionColor}
            items={item?.field_additional_value_ulimited}
            title={item?.field_paragraph_title[0]?.value}
            description={isItUndefined(item?.field_description_formatted)}
            checkedIcon={getRegionIcon(
              props?.regionColor && props?.regionColor !== 'none'
                ? props?.regionColor
                : getEditorColor(
                    isItUndefined(props?.children?.field_formatted_title)
                  )
            )}
            dataSet={props?.facilityAcordionData}
            subAccordion={item?.field_sub_accordion?.sub_accordion}
            version={isItUndefined(item?.field_sub_accordion_version)}
            accordionVariant={accordionVariant}
            cta={item?.field_cta_bar_button_selection[0]?.cta_bar_button}
            chipValue={isItUndefined(item?.field_accordion_chip_value)}
            spanColor={getEditorColor(
              isItUndefined(props?.children?.field_formatted_title)
            )}
            isIcon={isItUndefined(item?.field_use_icon_in_head_section)}
            bgColor={isItUndefined(props?.children?.field_text_color)}
            lang={props?.lang}
            global={props?.global}
            emphasizedTextColor={emphasizedTextColor}
            isCertificationsPage={isCertificationsPage}
          />
        </div>
      );
    });
  };

  const getAccordionVariantClass = (value) => {
    let className;
    switch (value) {
      case '0':
        className = 'standard-accordion';
        break;
      case '1':
        className = 'accordion-with-chip';
        break;
      case '2':
        className = 'accordion-cta-standard';
        break;
      case '3':
        className = 'accordion-with-head-description';
        break;
      default:
        className = '';
    }
    return className;
  };

  return (
    <div
      className={`facility-accordion ${renderColor(isItUndefined(props?.children?.field_text_color), null)} ${getAccordionVariantClass(accordionVariant)} ${useTitleAsSmallHeadLine ? 'title-as-headline' : ''}`}
    >
      <div
        className={
          isCertificationsPage && accordionVariant == '3'
            ? 'inner-container cert-page-version'
            : 'inner-container'
        }
      >
        <div className="head-container">
          <span
            className={`accordion-main-title ${props?.regionColor} ${emphasizedTextColor ? emphasizedTextColor : ''}`}
            dangerouslySetInnerHTML={{
              __html: cleanHTML(
                modifyLinks(
                  isItUndefined(props?.children?.field_formatted_title)
                )
              ),
            }}
          />
          {accordionVariant == '3' &&
            isItUndefined(props.children?.field_description) && (
              <span
                className={`accordion-head-description ${emphasizedTextColor ? emphasizedTextColor : ''}`}
                dangerouslySetInnerHTML={{
                  __html: cleanHTML(
                    modifyLinks(
                      isItUndefined(props?.children?.field_description)
                    )
                  ),
                }}
              />
            )}
        </div>
        <div className="accordions">{renderAccordions(data)}</div>
        {initialData.length > 5 && (
          <div
            onClick={() => {
              if (data.length <= 5) {
                setData(initialData);
              } else {
                setData(initialData.slice(0, 5));
              }
            }}
            className="show-more"
          >
            {data.length <= 5
              ? props?.global?.field_see_more_text &&
                props?.global?.field_see_more_text[0] &&
                props?.global?.field_see_more_text[0]?.value
                ? props?.global?.field_see_more_text[0]?.value
                : 'See More'
              : props?.global?.field_see_less &&
                  props?.global?.field_see_less[0] &&
                  props?.global?.field_see_less[0]?.value
                ? props?.global?.field_see_less[0].value
                : 'See Less'}
          </div>
        )}
      </div>
    </div>
  );
};

export default FacilityAccordionBlock;
